import deepFreeze from 'deep-freeze-strict';

export class ModelView<T> {
    protected readonly item: Readonly<T>;

    constructor(item: T) {
        this.item = deepFreeze(item);
    }
}
